import { gqlSystemRoleCode as SYSTEM_ROLE, gqlProfileFromEnum, gqlAccountRecoveryType } from '@minecraft.graphql-types';

export const LANG = 'en';

export const ACC_CLAIM_LIMIT = 5;

export const MULTIPLE_TIME_QUALIFIED_ROLES: string[] = [
  SYSTEM_ROLE.CASTING_DIRECTOR,
  SYSTEM_ROLE.AGENT,
  SYSTEM_ROLE.MANAGER,
];

export const STEP = {
  TALENT_SELECT_PROFILE_PAGE: 'talent_select_profile',
  TALENT_ARTIST_IDENTIFICATION: 'talent_artist_identification',
  TALENT_MAP_PROFILES: 'talent_map_profiles',
  TALENT_PERSONAL_PROFILE: 'talent_personal_profile',
};

export const PERSONAL_PROFILE_FROM = {
  NEW: 'NEW',
  REP: 'REP',
  UNREP: 'UNREP',
  NONE: 'NONE',
} as gqlProfileFromEnum;

export type recoveryStepType = 'main' | 'email' | 'phone' | 'names';

export const ACCOUNT_RECOVERY_STEP = {
  MAIN: 'main',
  EMAIL: 'email',
  PHONE: 'phone',
  NAMES: 'names',
} as { [key: string]: recoveryStepType };

export const ACCOUNT_RECOVERY_TYPE = {
  EMAIL_AND_PHONE: 'EmailAndPhone',
  PROJECT: 'Project',
  STAGENAME: 'StageName',
} as { [key: string]: gqlAccountRecoveryType };

export type stepEnum = 'EmailAndPhone' | 'Phone' | 'Email';

export const STEP_ALLOWED = {
  EMAIL_AND_PHONE: 'EmailAndPhone',
  PHONE: 'Phone',
  EMAIL: 'Email',
} as { [key: string]: stepEnum };

export type HandledDataType = {
  email?: string;
  phone?: string;
  name?: string;
  accountRecoveryType: gqlAccountRecoveryType;
};
